import { useMemo } from "react";
// Local
import InvoiceTable from "./InvoiceTable";
import { ExistingStiltInvoice } from "../../models/invoice";
import { QBOInvoiceResponse } from "../../Pages/Quickbooks/QuickbooksSyncErrorsContainer";
import { ExistingSiteKeyLocation } from "../../models/site-key-location";

interface Props {
  invoices: ExistingStiltInvoice[];
  currency: string;
  onViewInvoice: (invoiceID: string, acctRefID: string | null) => void;
  onImportSelected: (ids: string[]) => Promise<void>;
  qboInvoices: QBOInvoiceResponse[] | undefined;
  qboInvoicesLoading: boolean;
  siteKeyLocationList: ExistingSiteKeyLocation[];
  children: {
    dateRangePicker: React.ReactNode;
    qboLoadingInvoicesIndicator: React.ReactNode;
  };
}

/** Import Option: Single, Data Type: All Invoices */
export default function ImportSingleAllInvoicesContent(
  props: Props,
): JSX.Element {
  const filteredInvoices = useMemo(() => {
    return props.invoices.filter(
      (invoice) => invoice.customData.accountingRefID,
    );
  }, [props.invoices]);

  return (
    // <div>
    <InvoiceTable
      invoiceList={filteredInvoices}
      siteKeyLocationList={props.siteKeyLocationList}
      currency={props.currency}
      onViewInvoice={props.onViewInvoice}
      onImportSelected={props.onImportSelected}
      qboInvoices={props.qboInvoices}
      qboInvoicesLoading={props.qboInvoicesLoading}
    >
      {{
        dateRangePicker: props.children.dateRangePicker,
        qboLoadingInvoicesIndicator: props.children.qboLoadingInvoicesIndicator,
      }}
    </InvoiceTable>
    // </div>
  );
}
